import * as React from 'react'
import Container from '@mui/material/Container'
import Paper from '@mui/material/Paper'

interface Props {
  children: React.ReactNode
  overlapTop?: boolean
  width?: 'xl' | 'lg' | 'md' | 'sm'
  centered?: boolean
}

const ElevatedCard = ({
  children,
  overlapTop,
  width = 'lg',
  centered = false,
}: Props) => (
  <Container maxWidth={width}>
    <Paper
      elevation={2}
      sx={{
        p: {
          md: 6,
          xs: 3,
        },
        textAlign: centered ? 'center' : 'left',
        borderRadius: 6,
        position: overlapTop ? 'relative' : 'static',
        top: {md: overlapTop ? -80 : 0, xs: 0},
        mb: {md: overlapTop ? -10 : 0, xs: 0},
      }}
    >
      {children}
    </Paper>
  </Container>
)

export default ElevatedCard
